import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MarketTileAllTimeHigh = ({ data, formatNumber, animate }) => {
  const apiAth = data?.s06?.bitcoin?.market_data?.ath?.usd;
  
  const numberValue = apiAth != null
    ? `$${formatNumber(apiAth, 0)} USD`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="All-Time High" value={numberValue} />
    </ThemedFlex>
  );
};
